import types from '../mutation-types';
import AcessoAPI from '../../api/acesso';
import authAPI from '../../api/auth';

// ACESSO-01 (L8a): o acesso da pessoa na conta atual, pelos escopos `módulo:ação` que o servidor decide.
//
// - A chave `ACESSO_GRANULAR`, os escopos efetivos e a versão saem do perfil já carregado (o `acesso_granular` e o
//   `accounts[].acesso` do `_user.json.jbuilder`), e não de uma requisição por tela: são getters sobre o `auth`, e
//   mudam junto com o perfil.
// - O catálogo (os módulos, os escopos, os grupos e os modelos, com os rótulos) é da tela que o mostra: vem sob demanda,
//   uma vez, e de novo só a pedido, porque o grupo que a conta cria entra nele.
// - O `acesso.atualizado` (`helper/actionCable.js`) traz a versão nova da conta atual. Acima da do perfil, o perfil é
//   relido no lugar, sem logout nem reload; a falha o deixa como estava, até o próximo aviso ou a próxima carga.
//
// Com a chave desligada, quem decide na tela é o de hoje (`permissionsHelper`, `usePolicy`, o `meta.permissions`), e
// não estes escopos, que o servidor calcula com ela ligada ou não.
const acessoDaConta = rootGetters =>
  rootGetters.getCurrentAccount?.acesso || {};

export const state = {
  catalogo: null,
  uiFlags: {
    carregandoCatalogo: false,
  },
};

export const getters = {
  ligado: (_state, _getters, _rootState, rootGetters) =>
    rootGetters.getCurrentUser?.acesso_granular === true,
  escopos: (_state, _getters, _rootState, rootGetters) =>
    acessoDaConta(rootGetters).escopos || [],
  versao: (_state, _getters, _rootState, rootGetters) =>
    acessoDaConta(rootGetters).acesso_versao ?? null,
  catalogo: $state => $state.catalogo,
  uiFlags: $state => $state.uiFlags,
};

export const actions = {
  carregarCatalogo: async (
    { state: $state, commit },
    { recarregar = false } = {}
  ) => {
    if ($state.catalogo && !recarregar) return $state.catalogo;
    commit(types.SET_ACESSO_UI_FLAG, { carregandoCatalogo: true });
    try {
      const { data } = await AcessoAPI.catalogo();
      commit(types.SET_ACESSO_CATALOGO, data);
      return data;
    } finally {
      commit(types.SET_ACESSO_UI_FLAG, { carregandoCatalogo: false });
    }
  },

  // O aviso da versão que já está no perfil (ou de uma mais velha) não relê nada.
  atualizado: async (
    { getters: $getters, dispatch },
    { acesso_versao: nova }
  ) => {
    if ($getters.versao !== null && nova <= $getters.versao) return;
    await dispatch('reler');
  },

  // ACESSO-01 (L8b): a releitura do perfil, sem conferir versão. É a do `atualizado`, e a da reconexão
  // (`ReconnectService`): um `acesso.atualizado` perdido com o cabo caído só chegaria no próximo aviso.
  // ACESSO-01 (L11b): ao fim dela, o router confere de novo a página aberta (`conferirRotaAberta`, em
  // `routes/index.js`, que assina esta ação pelo nome).
  reler: async ({ commit }) => {
    try {
      const { data } = await authAPI.profile();
      commit(types.SET_CURRENT_USER, data, { root: true });
    } catch (error) {
      // O perfil fica como estava.
    }
  },
};

export const mutations = {
  [types.SET_ACESSO_CATALOGO]($state, catalogo) {
    $state.catalogo = catalogo;
  },
  [types.SET_ACESSO_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
